export default {
	meta: {
		title: 'Fiche de patient',
		description: 'Fiche de patient'
	},
	subPage: {
		unspecified: 'Non renseigné'
	},
	survey: {
		outof: 'SUR'
	}
};
